import React from "react";
import { cn } from "@/lib/utils";

const WATER_COLORS = {
  LOW: "bg-amber-100 border-amber-400 text-amber-950",
  NORMAL: "bg-emerald-100 border-emerald-500 text-emerald-950",
  HIGH: "bg-red-100 border-red-500 text-red-950",
};

const HUSK_COLORS = {
  STOPPED: "bg-slate-200 border-slate-400 text-slate-800",
  RUNNING: "bg-emerald-100 border-emerald-500 text-emerald-950",
};

function pressureTone(value, limits) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "bg-card border-border text-foreground";
  if (n < limits.warn_low) return "bg-amber-100 border-amber-500 text-amber-950";
  if (n > limits.warn_high) return "bg-red-100 border-red-500 text-red-950";
  return "bg-emerald-50 border-emerald-400 text-emerald-950";
}

/** Large tap target card for a boiler reading or toggle. */
export default function BoilerReadingCard({
  label,
  display,
  sublabel = "Tap to edit",
  toneClass = "bg-card border-border text-foreground",
  onClick,
  disabled = false,
  testId,
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "rounded-2xl border-2 p-4 sm:p-5 text-left w-full min-h-[120px] touch-manipulation transition-transform active:scale-[0.98]",
        "disabled:opacity-50 disabled:pointer-events-none",
        toneClass,
      )}
    >
      <div className="text-[10px] sm:text-xs uppercase tracking-widest opacity-70">{label}</div>
      <div className="font-mono text-2xl sm:text-3xl font-bold mt-2 tabular-nums leading-tight">{display}</div>
      <div className="text-[10px] sm:text-xs mt-3 opacity-60">{sublabel}</div>
    </button>
  );
}

export function steamPressureCardTone(value, limits) {
  return pressureTone(value, limits);
}

export function waterLevelCardTone(level) {
  return WATER_COLORS[level] || WATER_COLORS.NORMAL;
}

export function huskFeedCardTone(status) {
  return HUSK_COLORS[status] || HUSK_COLORS.STOPPED;
}

export function formatPressure(value) {
  if (value == null || value === "") return "—";
  return `${value} kg/cm²`;
}

export function formatTemp(value) {
  if (value == null || value === "") return "—";
  return `${value} °C`;
}
